export class HelpersModule {

  static cloudinaryURLForceWidth(url: string, width: number): string {

    if (url.indexOf("/upload") > 0) {

      let u: string = url;
      const pos: number = url.indexOf("/upload") + 7;

      u = url.slice(0, pos) + "/w_" + width.toString() + ",c_scale,q_auto:best,f_auto" + url.slice(pos);

      return u;

    }
    else {
      return url;
    }

  }

}
